var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDownload = function SvgIcDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#070707",
    fillRule: "evenodd",
    d: "M13,14.5857864 L16.2928932,11.2928932 L17.7071068,12.7071068 L12,18.4142136 L6.29289322,12.7071068 L7.70710678,11.2928932 L11,14.5857864 L11,6 L13,6 L13,14.5857864 Z"
  })));
};
export default SvgIcDownload;